var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComments = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 1.5v7.969c0 .827-.673 1.5-1.5 1.5h-.508v-1h.508a.5.5 0 0 0 .5-.5V1.5a.5.5 0 0 0-.5-.5h-14a.5.5 0 0 0-.5.5v7.969a.5.5 0 0 0 .5.5H3v2.892l1.779-1.569.661.75L2 15.077v-4.108h-.5c-.827 0-1.5-.673-1.5-1.5V1.5C0 .673.673 0 1.5 0h14c.827 0 1.5.673 1.5 1.5m-2.98 8.04v3.043c0 .827-.673 1.5-1.5 1.5h-.5v3.064l-3.667-3.064H7.5c-.827 0-1.5-.673-1.5-1.5V9.54c0-.827.673-1.5 1.5-1.5h5.02c.827 0 1.5.673 1.5 1.5m-1 0a.5.5 0 0 0-.5-.5H7.5a.5.5 0 0 0-.5.5v3.043a.5.5 0 0 0 .5.5h1.217l2.303 1.926v-1.926h1.5a.5.5 0 0 0 .5-.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComments);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/comments.svg";